import * as React from 'react';
import { Outside } from '@cian/ui-kit';
import { useDispatch, useSelector } from 'react-redux';
import { TDispatch } from '../../types/redux';
import { changeAdultCount, changeChildrenCount } from '../../actions/filters';
import { selectGuests } from '../../selectors/filters/guests';
import { FilterGuests } from '../../components/FilterGuests';
import { GuestsDropdown } from '../../components/GuestsDropdown';
import { formatGuests } from './utils/formatGuests';
import { useToggleState } from '../../hooks';
import { trackFilterGuestsClick } from './tracking';

export const FilterGuestsContainer = () => {
  const { adults, children } = useSelector(selectGuests);
  const dispatch = useDispatch<TDispatch>();

  const [dropdownOpen, toggleDropdown] = useToggleState();

  const guests = React.useMemo(() => formatGuests({ adults, children }), [adults, children]);

  const handleChangeAdults = React.useCallback(
    (adults: number) => {
      dispatch(changeAdultCount(adults));
    },
    [dispatch],
  );

  const handleChangeChildren = React.useCallback(
    (children: number) => {
      dispatch(changeChildrenCount(children));
    },
    [dispatch],
  );

  const handleFilterClick = React.useCallback(() => {
    toggleDropdown();

    if (!dropdownOpen) {
      trackFilterGuestsClick();
    }
  }, [toggleDropdown, dropdownOpen]);

  return (
    <Outside active={dropdownOpen} onOutside={toggleDropdown}>
      <FilterGuests filterText={guests} active={dropdownOpen} onFilterClick={handleFilterClick}>
        {dropdownOpen && (
          <GuestsDropdown
            adults={adults}
            // eslint-disable-next-line react/no-children-prop
            children={children}
            onChangeAdults={handleChangeAdults}
            onChangeChildren={handleChangeChildren}
          />
        )}
      </FilterGuests>
    </Outside>
  );
};
